<template>
    <div class="stock-record-container">
        <!-- 筛选区域 -->
        <div class="filter-card">
            <el-form :inline="true" :model="searchForm" class="search-form" size="medium">
                <el-form-item label="仓库名称">
                    <el-select v-model="searchForm.warehouseId" placeholder="全部仓库" clearable>
                        <el-option label="全部仓库" value=""></el-option>
                        <el-option v-for="warehouse in warehouseList" :key="warehouse.houseId"
                            :label="warehouse.houseName" :value="warehouse.houseId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="操作类型">
                    <el-select v-model="searchForm.operateType" placeholder="全部类型" clearable>
                        <el-option label="全部类型" value=""></el-option>
                        <el-option label="入库" value="in"></el-option>
                        <el-option label="出库" value="out"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="食材名称/编码">
                    <el-input v-model="searchForm.materialKeyword" placeholder="输入食材名称或编码" clearable></el-input>
                </el-form-item>
                <!-- <el-form-item label="操作时间">
                    <el-date-picker v-model="searchForm.timeRange" type="operationDaterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                        clearable></el-date-picker>
                </el-form-item> -->
                <el-form-item>
                    <el-button type="primary" @click="getRecordList" icon="el-icon-search">查询</el-button>
                    <el-button @click="resetSearch" icon="el-icon-refresh">重置</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- 记录列表 -->
        <div class="record-table-card">
            <el-table v-loading="loading" :data="recordList" border style="width: 100%" height="65vh"
                :header-cell-class-name="'table-header'" @row-click="handleRowClick" ref="table" row-key="numId">
                <el-table-column label="序号" type="index" width="80" align="center" />
                <el-table-column prop="numId" label="流水号" align="center" width="180" />
                <el-table-column prop="productName" label="食材名称" align="center" width="180" />
                <el-table-column prop="shelfLife" label="保质期" align="center" width="120" />
                <el-table-column prop="untilExpiration" label="临期时间" align="center" width="120" />
                <el-table-column prop="outFreezer" label="操作类型" align="center" width="120">
                    <template slot-scope="scope">
                        <el-tag :type="['1', 1].includes(scope.row.outFreezer) ? 'success' : 'warning'">
                            {{ ['1', 1].includes(scope.row.outFreezer) ? '入库' : '出库' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="vendors" label="供应商" align="center" width="120" />
                <el-table-column prop="num" label="库存量" align="center" width="120" />
                <el-table-column prop="unit" label="库存单位" align="center" width="150" />
                <el-table-column prop="base64Data" label="食材图片" align="center" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.base64Data" class="image-container">
                            <el-image :src="scope.row.base64Data" :preview-src-list="[scope.row.base64Data]" fit="cover"
                                style="width: 60px; height: 60px; border-radius: 4px"
                                :alt="scope.row.productName + '图片'">
                                <div slot="error" class="image-error">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                        </div>
                        <div v-else class="image-error">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="expiryDate" label="临期日期" align="center" width="150">
                    <template slot-scope="scope">
                        <span
                            :class="scope.row.expiryDate ? (isExpired(scope.row.expiryDate) ? 'text-red-500 font-bold' : 'text-orange-500 font-bold') : ''">
                            {{ scope.row.expiryDate || '无' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="仓库名称" align="center" width="150">
                    <template slot-scope="scope">
                        {{ getWarehouseNameById(scope.row.houseId) || '未知仓库' }}
                    </template>
                </el-table-column>
                <el-table-column prop="room" label="功能间" align="center" width="150" />
                <el-table-column prop="operator" label="操作人" align="center" width="120" />
                <el-table-column prop="operationDate" label="操作时间" align="center" width="200" />
            </el-table>

            <!-- 分页 -->
            <div class="pagination-container" v-if="total > 0">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total" background>
                </el-pagination>
            </div>

            <!-- 空数据提示 -->
            <div class="empty-tip" v-else>
                <el-empty description="暂无出入库记录数据"></el-empty>
            </div>
        </div>

        <!-- 详情弹窗 -->
        <el-dialog title="出入库记录详情" :visible.sync="detailVisible" width="700px" append-to-body>
            <div v-if="currentRecord" class="detail-content">
                <el-descriptions :column="2" border>
                    <el-descriptions-item label="流水号" :span="2">{{ currentRecord.numId || '无' }}</el-descriptions-item>
                    <el-descriptions-item label="食材名称">{{ currentRecord.productName || '无' }}</el-descriptions-item>
                    <el-descriptions-item label="操作类型">
                        <el-tag :type="['1', 1].includes(currentRecord.outFreezer) ? 'success' : 'warning'">
                            {{ ['1', 1].includes(currentRecord.outFreezer) ? '入库' : '出库' }}
                        </el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item label="库存量">{{ currentRecord.num || 0 }} {{ currentRecord.unit || '无'
                        }}</el-descriptions-item>
                    <el-descriptions-item label="保质期">{{ currentRecord.shelfLife || '无' }}</el-descriptions-item>
                    <el-descriptions-item label="临期时间">{{ currentRecord.untilExpiration || '无' }}</el-descriptions-item>
                    <el-descriptions-item label="临期日期">
                        <span
                            :class="isExpired(currentRecord.expiryDate) ? 'text-red-500 font-bold' : 'text-orange-500 font-bold'">
                            {{ currentRecord.expiryDate || '无' }}
                        </span>
                    </el-descriptions-item>
                    <el-descriptions-item label="供应商">{{ currentRecord.vendors || '无' }}</el-descriptions-item>
                    <el-descriptions-item label="仓库名称">{{ getWarehouseNameById(currentRecord.houseId) || '未知仓库'
                        }}</el-descriptions-item>
                    <el-descriptions-item label="功能间">{{ currentRecord.room || '无' }}</el-descriptions-item>
                    <el-descriptions-item label="操作人">{{ currentRecord.operator || '无' }}</el-descriptions-item>
                    <el-descriptions-item label="操作时间">{{ currentRecord.operationDate || '无' }}</el-descriptions-item>
                </el-descriptions>
                <div class="detail-image" v-if="currentRecord.base64Data">
                    <h4>食材图片</h4>
                    <el-image :src="currentRecord.base64Data" fit="contain" style="max-height: 300px; width: 100%;" />
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="detailVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getStoreOperation } from "@/api/record";
import { getHouseList, getHouseListByPid } from "@/api/terminal";

export default {
    name: 'WarehouseStockRecord',
    data() {
        return {
            imageBaseUrl: 'data:image/png;base64,',
            searchForm: {
                warehouseId: '',
                operateType: '',
                materialKeyword: '',
                timeRange: [],
                operator: ''
            },
            warehouseList: [],
            recordList: [],      // 当前页显示的记录
            allRecords: [],       // 所有符合条件的记录
            total: 0,             // 总记录数
            currentPage: 1,       // 当前页码
            pageSize: 10,         // 每页显示数量
            detailVisible: false,
            currentRecord: null,
            loading: false
        }
    },
    mounted() {
        this.loadSubWarehouseList().then(() => {
            this.getRecordList(); // 首次加载数据
        });
    },
    methods: {
        /**
         * @description 加载子仓库列表
         */
        async loadSubWarehouseList() {
            try {
                const params = { userId: localStorage.getItem('userId'), pid: null };
                const mainWarehouseRes = await getHouseList(params);
                if (mainWarehouseRes && mainWarehouseRes.code === 200) {
                    const mainWarehouses = mainWarehouseRes.data || [];
                    const subWarehouseList = [];
                    for (const mainWarehouse of mainWarehouses) {
                        const subWarehouseRes = await getHouseListByPid({
                            userId: localStorage.getItem('userId'),
                            pid: mainWarehouse.houseId
                        });
                        if (subWarehouseRes && subWarehouseRes.code === 200) {
                            const subWarehouses = subWarehouseRes.data || [];
                            const pureSubWarehouses = subWarehouses.filter(item => item.pid && item.pid !== item.houseId);
                            subWarehouseList.push(...pureSubWarehouses);
                        }
                    }
                    this.warehouseList = subWarehouseList;
                }
            } catch (error) {
                console.error('加载子仓列表失败:', error);
                this.$message.error('子仓列表加载失败，将使用默认子仓数据');
                this.warehouseList = [
                    { houseId: 101, houseName: '面食子仓-一区', pid: 1 },
                    { houseId: 102, houseName: '面食子仓-二区', pid: 1 },
                    { houseId: 201, houseName: '冷冻子仓-低温区', pid: 2 },
                    { houseId: 202, houseName: '冷冻子仓-常温区', pid: 2 },
                ];
            }
        },

        /**
         * @description 根据仓库ID获取仓库名称
         * @param {number|string} houseId
         * @returns {string}
         */
        getWarehouseNameById(houseId) {
            if (!houseId) return '';
            const warehouse = this.warehouseList.find(item =>
                item.houseId == houseId || item.houseId === String(houseId)
            );
            return warehouse ? warehouse.houseName : '';
        },

        /**
         * @description 新增：前端兜底筛选（核心修复）
         */
        filterData(rawData) {
            if (!Array.isArray(rawData)) return [];

            return rawData.filter(item => {
                // 1. 仓库筛选
                if (this.searchForm.warehouseId && item.houseId != this.searchForm.warehouseId) {
                    return false;
                }

                // 2. 操作类型筛选（in=入库=1，out=出库=非1）
                if (this.searchForm.operateType) {
                    const isIn = ['1', 1].includes(item.outFreezer);
                    if (this.searchForm.operateType === 'in' && !isIn) return false;
                    if (this.searchForm.operateType === 'out' && isIn) return false;
                }

                // 3. 食材名称/编码关键词筛选
                if (this.searchForm.materialKeyword) {
                    const keyword = this.searchForm.materialKeyword.toLowerCase().trim();
                    const productName = (item.productName || '').toLowerCase();
                    const numId = (item.numId || '').toLowerCase(); // 流水号/编码
                    if (!productName.includes(keyword) && !numId.includes(keyword)) {
                        return false;
                    }
                }

                // 4. 时间范围筛选
                if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
                    const start = new Date(this.searchForm.timeRange[0]).setHours(0, 0, 0, 0);
                    const end = new Date(this.searchForm.timeRange[1]).setHours(23, 59, 59, 999);
                    const recordTime = new Date(item.operationDate).setHours(0, 0, 0, 0);
                    if (recordTime < start || recordTime > end) {
                        return false;
                    }
                }

                return true;
            });
        },

        /**
         * @description 核心方法：获取记录列表（支持筛选）
         */
        getRecordList() {
            this.loading = true;
            // 1. 修复：转换筛选参数（关键）
            const params = {
                userId: localStorage.getItem('userId'),
                warehouseId: this.searchForm.warehouseId || '',
                // 操作类型转换：in→1，out→0，空→不传
                operateType: this.searchForm.operateType === 'in' ? 1 : (this.searchForm.operateType === 'out' ? 0 : ''),
                materialKeyword: this.searchForm.materialKeyword || '',
            };

            // 2. 处理时间范围参数
            if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
                params.startTime = this.searchForm.timeRange[0];
                params.endTime = this.searchForm.timeRange[1];
            }

            // 3. 调用接口
            getStoreOperation(params).then(res => {
                this.loading = false;
                if (res && res.code === 200) {
                    // 4. 修复：先前端筛选，再分页
                    const filteredData = this.filterData(res.data || []);
                    this.allRecords = filteredData;
                    this.total = this.allRecords.length;
                    this.currentPage = 1;
                    this.paginateRecords();
                } else {
                    this.$message.error(res.message || '获取数据失败');
                    this.allRecords = [];
                    this.recordList = [];
                    this.total = 0;
                }
            }).catch(error => {
                this.loading = false;
                console.error('API请求异常:', error);
                this.$message.error('网络异常，请稍后重试');
                this.allRecords = [];
                this.recordList = [];
                this.total = 0;
            });
        },

        /**
         * @description 根据当前页码和每页数量进行分页
         */
        paginateRecords() {
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            this.recordList = this.allRecords.slice(startIndex, endIndex);
        },

        /**
         * @description 重置筛选条件
         */
        resetSearch() {
            this.searchForm = {
                warehouseId: '',
                operateType: '',
                materialKeyword: '',
                timeRange: [],
                operator: ''
            };
            this.currentPage = 1;
            this.getRecordList();
        },

        /**
         * @description 每页数量改变时触发
         */
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.paginateRecords();
        },

        /**
         * @description 当前页改变时触发
         */
        handleCurrentChange(val) {
            this.currentPage = val;
            this.paginateRecords();
        },

        /**
         * @description 点击表格行，显示详情弹窗
         */
        handleRowClick(row) {
            if (this.$refs.table) {
                this.$refs.table.clearSelection();
                this.$refs.table.toggleRowSelection(row, true);
            }
            this.viewDetail(row);
        },

        /**
         * @description 显示详情弹窗
         */
        viewDetail(record) {
            this.currentRecord = { ...record };
            this.detailVisible = true;
        },

        /**
         * @description 判断是否已过期
         */
        isExpired(expiryDate) {
            if (!expiryDate) return false;
            try {
                const today = new Date().setHours(0, 0, 0, 0);
                const expDate = new Date(expiryDate).setHours(0, 0, 0, 0);
                return expDate < today;
            } catch (e) {
                return false;
            }
        },

        /**
         * @description 导出记录（待实现）
         */
        exportRecords() {
            this.$message.info('导出功能已触发，正在生成Excel文件...');
            setTimeout(() => {
                this.$message.success('出入库记录导出成功，已开始下载');
            }, 1500);
        },
    }
}
</script>

<style lang="scss" scoped>
.stock-record-container {
    padding: 20px;
    background-color: #fafbfc;
    min-height: 100vh;
}

.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    h2 {
        font-size: 18px;
        font-weight: 500;
        color: #1f2937;
        margin: 0;
    }

    .header-actions {
        display: flex;
        gap: 12px;
    }
}

.filter-card {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    padding: 16px;
    margin-bottom: 20px;
}

.search-form {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: center;
}

.record-table-card {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    padding: 20px;
    height: 70vh;
    display: flex;
    flex-direction: column;
}

.el-table {
    flex: 1;
    width: 100%;
    --el-table-header-text-color: #1890ff;
    --el-table-header-row-bg-color: #f0f7ff;
}

.pagination-container {
    margin-top: 20px;
    text-align: right;
}

.empty-tip {
    padding: 60px 0;
    text-align: center;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.detail-content {
    padding: 10px 0;
}

.text-red-500 {
    color: #f56c6c;
}

.text-orange-500 {
    color: #e6a23c;
}

.font-bold {
    font-weight: 500;
}

.dialog-footer {
    text-align: right;
}

.image-error {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
    color: #8c939d;
    border-radius: 4px;
}

.detail-image {
    margin-top: 20px;

    h4 {
        font-size: 14px;
        color: #4b5563;
        margin-bottom: 8px;
        font-weight: 500;
    }
}
</style>